import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

import SelectJobGroupPopup from './popup/SelectJobGroupPopup';

const SelectJobGroupPage = () => {
  const { state } = useLocation();

  const handlePopupClose = () => {};
  const handlePopupConfirm = () => {};

  return (
    <Container>
      <SelectJobGroupPopup
        open={true}
        isNeedSelect={true}
        onConfirm={handlePopupConfirm}
        onClose={handlePopupClose}
        ssoUserInfo={state?.ssoUserInfo}
      ></SelectJobGroupPopup>
    </Container>
  );
};

export default SelectJobGroupPage;

const Container = styled(FlexBoxColumn)`
  height: 100vh;
  justify-content: center;
`;
